(() => {
  'use strict';
  if (window.vpRecentlyViewedReady) return;
  const configNode = document.querySelector('[data-vp-recent-config]');
  const dialog = document.getElementById('vp-recent-dialog');
  if (!configNode || !dialog) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  window.vpRecentlyViewedReady = true;
  const key = 'vanpasch:recently-viewed:v1';
  const maxAge = 180 * 24 * 60 * 60 * 1000;
  const grid = dialog.querySelector('[data-vp-recent-grid]');
  const empty = dialog.querySelector('[data-vp-recent-empty]');
  const status = dialog.querySelector('[data-vp-recent-status]');
  const root = config.root.replace(/\/?$/, '/');
  let list = [];
  let storageAvailable = true;
  let opener = null;
  let run = 0;
  const valid = p => p && typeof p.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(p.handle) && typeof p.title === 'string' && Number.isFinite(p.seenAt) && Date.now() - p.seenAt < maxAge;
  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(valid).slice(0, 36) : [];
    } catch { storageAvailable = false; return list; }
  }
  function save() {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch { storageAvailable = false; }
  }
  list = read();
  if (config.product) {
    const current = { ...config.product, seenAt: Date.now() };
    list = [current, ...list.filter(p => p.handle !== current.handle)].slice(0, 36);
    save();
  }
  function money(value) {
    try { return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(value / 100); } catch { return ''; }
  }
  function imageUrl(value) {
    if (typeof value !== 'string') return null;
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || !['cdn.shopify.com', location.hostname].includes(url.hostname)) return null;
      url.searchParams.set('width', '480');
      return url.href;
    } catch { return null; }
  }
  function render(items) {
    grid.replaceChildren();
    empty.hidden = items.length !== 0;
    for (const p of items) {
      const card = document.createElement('a');
      card.className = 'vp-recent-card';
      card.href = root + 'products/' + encodeURIComponent(p.handle);
      const media = document.createElement('div');
      media.className = 'vp-recent-media';
      const src = imageUrl(p.image);
      if (src) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = p.title;
        img.width = 480;
        img.height = 480;
        img.loading = 'lazy';
        img.decoding = 'async';
        media.append(img);
      }
      const title = document.createElement('h3');
      title.textContent = p.title;
      const price = document.createElement('p');
      price.className = 'vp-recent-price';
      price.textContent = Number.isFinite(p.price) ? money(p.price) : '';
      card.append(media, title, price);
      if (p.available === false) {
        const label = document.createElement('span');
        label.className = 'vp-recent-stock';
        label.textContent = config.soldOut;
        card.append(label);
      }
      grid.append(card);
    }
  }
  async function refresh(token) {
    const snapshot = list.slice();
    const results = new Array(snapshot.length);
    let index = 0;
    async function worker() {
      while (index < snapshot.length) {
        const i = index++;
        const p = snapshot[i];
        try {
          const response = await fetch(root + 'products/' + encodeURIComponent(p.handle) + '.js', { signal: AbortSignal.timeout(6000), credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (response.status === 404 || response.status === 410) { results[i] = null; continue; }
          if (!response.ok) throw new Error('unavailable');
          const fresh = await response.json();
          results[i] = { ...p, title: fresh.title, price: fresh.price, available: fresh.available, image: fresh.featured_image || p.image };
        } catch { results[i] = p; }
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, snapshot.length) }, worker));
    if (token !== run) return;
    list = results.filter(Boolean);
    save();
    render(list);
    status.textContent = storageAvailable ? '' : config.unavailable;
  }
  function close() { dialog.close(); }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-vp-recent-trigger]');
    if (!trigger) return;
    opener = trigger;
    list = read();
    render(list);
    status.textContent = list.length ? config.loading : (storageAvailable ? '' : config.unavailable);
    document.documentElement.classList.add('vp-recent-open');
    dialog.showModal();
    document.querySelectorAll('[data-vp-recent-trigger]').forEach(button => button.setAttribute('aria-expanded', 'true'));
    refresh(++run);
  });
  dialog.querySelector('[data-vp-recent-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  dialog.addEventListener('close', () => {
    run++;
    document.documentElement.classList.remove('vp-recent-open');
    document.querySelectorAll('[data-vp-recent-trigger]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus();
  });
  window.addEventListener('storage', event => { if (event.key === key) { list = read(); if (dialog.open) render(list); } });
})();
